import Swiper from 'swiper';
import DeviceManager from '../utils/device-manager';

export default function initSliderLogos() : void {
    const $sliderLogosContainers = document.querySelectorAll<HTMLElement>('.js-slider-logos');

    $sliderLogosContainers.forEach($container => {
        new SliderLogos($container);
    });
}

export class SliderLogos {
    $container: HTMLElement;
    swiper: Swiper;

    constructor($container: HTMLElement) {
        this.$container = $container;

        const swiperParams = {
            spaceBetween: 23,
            threshold: 10,
            centeredSlides: true,
            loop: true,
            loopAdditionalSlides: 5,
            breakpoints: {},
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            slidesPerView: 'auto',
            speed: 2000,
        };
        swiperParams.breakpoints[DeviceManager.devices.md] = {
            spaceBetween: 40,
        };

        this.swiper = new Swiper(this.$container, swiperParams);
    }
}
